import * as signalR from "@microsoft/signalr";
import axios from "axios";

const SIGNALR_BASE_URL = process.env.REACT_APP_SIGNALR_BASE_URL;

const USERNAME = "admin";
const PASSWORD = "password";
const BRANCH_ID_KEY = "app_branch_id";

const axiosClient = axios.create({
  baseURL: SIGNALR_BASE_URL,
  headers: { "Content-Type": "application/json" },
});

function createRandomUserId() {
  const chars = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  let part1 = "", part2 = "";
  for (let i = 0; i < 4; i++) {
    part1 += chars[Math.floor(Math.random() * chars.length)];
    part2 += chars[Math.floor(Math.random() * chars.length)];
  }
  return `${part1}-${part2}`;
}

function getUserId() {
  const existingBranchId = localStorage.getItem(BRANCH_ID_KEY);

  if (existingBranchId) {
    return existingBranchId;
  }

  const userId = localStorage.getItem("USER_ID");
  const randomId = createRandomUserId();
  const fullUserId = `branch:${userId}:${randomId}`;

  localStorage.setItem(BRANCH_ID_KEY, fullUserId);

  return fullUserId;
}

async function fetchAuthToken() {
  const userId = getUserId();
  const response = await axiosClient.post("/generate-token", {
    username: USERNAME,
    password: PASSWORD,
    userId,
  });
  if (!response.data?.token) throw new Error("No token received");
  return response.data.token;
}

// Always fetches a fresh token and creates a new connection
async function createSignalRConnection() {
  const token = await fetchAuthToken();

  const connection = new signalR.HubConnectionBuilder()
    .withUrl(`${SIGNALR_BASE_URL}/gatewayHub`, {
      accessTokenFactory: () => token,
      withCredentials: false,
    })
    .withAutomaticReconnect([0, 2000, 5000, 10000, 30000])
    .withKeepAliveInterval(15000)    // ping every 15s to prevent timeout
    .withServerTimeout(30000)        // wait 30s before considering server dead
    .configureLogging(signalR.LogLevel.Warning)
    .build();

  await connection.start();
  return connection;
}

export { createSignalRConnection };